/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/destructuring-assignment */
import React, { useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Autocomplete,
  Avatar,
  Box,
  Button,
  Card,
  Collapse,
  createFilterOptions,
  Grid,
  IconButton,
  Link,
  List,
  ListItem,
  ListItemText,
  TableCell,
  TextField,
  Tooltip,
  Typography,
  useTheme,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material';
import { DataGrid, GridActionsCellItem, frFR, GridToolbarContainer, GridToolbarColumnsButton, GridToolbarFilterButton, GridToolbarDensitySelector, GridToolbarExport } from '@mui/x-data-grid';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import * as Yup from 'yup';
import { Formik } from 'formik';
import moment from 'moment';
import toast from 'react-hot-toast';
import { pdf } from '@react-pdf/renderer';
import PDFMerger from 'pdf-merger-js';
import * as XLSX from 'xlsx';
import useAuth from '../../hooks/useAuth';
import { sessionApi } from '../../api/sessionApi';
import AttestationPDF from '../../components/AttestationPDF';
import { ProgressBar } from '../../components/dashboard/session';
import { dashboardApi } from '../../api/dashboardApi';
import { shiftApi } from '../../api/shiftApi';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { ListItemButton } from '@mui/material';
import { alpha } from '@mui/material/styles';
import numeral from 'numeral';

import ErrorIcon from '@mui/icons-material/Error';
import TimelapseIcon from '@mui/icons-material/Timelapse';
import WarningIcon from '@mui/icons-material/Warning';

const ShiftedLearnersTable = () => {
  const theme = useTheme();
  const [customersList, setCustomersList] = useState([]);
  const [session, setSession] = useState({});
  const [customers, setCustomers] = useState([]);
  const [rows, setRows] = useState([]);
  const [exporting, setExporting] = useState(false);
  const [show, setShow] = useState(false);
  const [showDec, setShowDec] = useState(false);
  const [currentIdDec, setCurrentIdDec] = useState(0);
  const { user } = useAuth();
  const [showAlert, setShowAlert] = useState(false);
  const [sources, setSources] = useState([]);
  const [amounts, setAmounts] = useState([]);

  const [clickedId, setClickedId] = useState(-1);

  const detailStyles = {
    borderLeft: '4px solid',
    borderLeftColor: '#10b981',
    backgroundColor: theme.palette.mode === 'light' ? 'rgba(241, 245, 249, 0.5)' : 'rgba(15, 23, 42, 0.25)',
    borderRadius: '16px',
    p: 3,
    my: 2,
    border: '1px solid',
    borderColor: theme.palette.mode === 'light' ? 'rgba(226, 232, 240, 0.8)' : 'rgba(255, 255, 255, 0.05)',
    whiteSpace: 'pre-line',
  };

  const CustomToolbar = () => (
    <GridToolbarContainer sx={{ p: 2, display: 'flex', gap: 1, borderBottom: `1px solid ${theme.palette.divider}` }}>
      <GridToolbarColumnsButton sx={{ fontWeight: 700, textTransform: 'none', fontSize: '0.8rem' }} />
      <GridToolbarFilterButton sx={{ fontWeight: 700, textTransform: 'none', fontSize: '0.8rem' }} />
      <GridToolbarDensitySelector sx={{ fontWeight: 700, textTransform: 'none', fontSize: '0.8rem' }} />
      <GridToolbarExport sx={{ fontWeight: 700, textTransform: 'none', fontSize: '0.8rem' }} />
    </GridToolbarContainer>
  );

  const filterOptions = createFilterOptions({
    limit: 100,
    stringify: (option) => `${option.email} ${option.firstname} ${option.lastname}`,
  });

  const handleShow = () => {
    setShow(!show);
  };

  // initialisation de la liste d'apprenants
  useEffect(() => {
    const init = async () => {
      console.clear();
      const data = await dashboardApi.getInfos(localStorage.getItem('accessToken'));
      setSources(data.sources);
    };
    init();
  }, []);

  // initialisation de la liste d'apprenants
  useEffect(() => {
    const init = async () => {
      const data = await shiftApi.getShiftCustomersList(localStorage.getItem('accessToken'));
      setRows(data[0].customers.map((item) => ({
        id: item.learner_session_id,
        customerId: item.customer_id,
        customer: item.customer,
        email: item.email,
        adeli_rpps: item.adeli_rpps,
        profession: item.profession,
        firstname: item.firstname,
        lastname: item.lastname,
        source: item.source,
        status: item.status,
        sessionId: item.session_id,
        primary_connection: item.primary_connection !== null ? moment(item.primary_connection).format('DD/MM/YYYY') : '',
        last_connection: item.last_connection !== null ? moment(item.last_connection).format('DD/MM/YYYY') : '',
        start_date: item.start_date !== null ? moment(item.start_date).format('DD/MM/YYYY') : '',
        end_date: item.end_date !== null ? moment(item.end_date).format('DD/MM/YYYY') : '',
        progression: Math.round(item.totalProgress),
        program_number: item.program_number,
        formation_name: item.formation_name,
        formation_id: item.formation_id,
        real_price: item.real_price,
        sourceId: item.source_id,
      })));

      // rcupération des chiffres par status
      setAmounts(data[1].amounts[0]);
      console.clear();
    };
    init();
  }, [customers]);

  const handleChange = async (params) => {
    if (params.field === 'primary_connection' || params.field === 'last_connection') {
      params.value = moment(params.value).format('YYYY-MM-DD HH:mm:ss');
    }
    if (params.field === 'real_price') {
      params.value = parseFloat(params.value).toFixed(3);
    }
    if (params.value === 'Décalé') {
      // On met la modale du choix de la session décalée à true
      setShowDec(true);
      setCurrentIdDec(params.id);
    } else {
      try {
        await sessionApi.editCustomer(2, params.id, params.value, localStorage.getItem('accessToken'), params.field);
      } catch (err) {
        console.error(err);
        toast.error('Il y a eu un souci lors de la modification !');
      }
    }
  };

  const columns = [
    {
      field: '+',
      renderCell: (cellValues) => (
        <IconButton 
          onClick={() => { clickedId === cellValues.row.id ? setClickedId(-1) : setClickedId(cellValues.row.id); }}
          sx={{ color: 'text.secondary' }}
        >
          {cellValues.row.id === clickedId ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        </IconButton>
      ),
      width: 60,
      sortable: false
    },
    {
      field: 'firstname',
      headerName: 'Prénom et Nom',
      renderCell: (cellValues) => (
        <Tooltip
          followCursor
          enterDelay={500}
          placement="top"
        >
          <Link
            component={RouterLink}
            to={`/dashboard/customers/${cellValues.row.customerId}`}
            sx={{
              textDecoration: 'none',
              fontWeight: 800,
              fontSize: '0.85rem',
              color: 'primary.main',
              '&:hover': { color: 'primary.dark' }
            }}
          >
            {`${cellValues.row.firstname} ${cellValues.row.lastname}`}
          </Link>
        </Tooltip>
      ),
      width: 200,
    },
    {
      field: 'status',
      headerName: 'Statut',
      type: 'singleSelect',
      renderCell: (cellValues) => {
        let bg = 'rgba(100, 116, 139, 0.08)';
        let color = '#64748b';
        let border = 'rgba(100, 116, 139, 0.2)';

        if (cellValues.row.status === 'Inscrit') {
          bg = theme.palette.mode === 'light' ? 'rgba(16, 185, 129, 0.06)' : 'rgba(16, 185, 129, 0.15)';
          color = '#10b981';
          border = 'rgba(16, 185, 129, 0.2)';
        } else if (cellValues.row.status === 'En attente' || cellValues.row.status === 'À transférer') {
          bg = theme.palette.mode === 'light' ? 'rgba(245, 158, 11, 0.06)' : 'rgba(245, 158, 11, 0.15)';
          color = '#f59e0b';
          border = 'rgba(245, 158, 11, 0.2)';
        } else if (cellValues.row.status === 'InscritD') {
          bg = theme.palette.mode === 'light' ? 'rgba(99, 102, 241, 0.06)' : 'rgba(99, 102, 241, 0.15)';
          color = '#6366f1';
          border = 'rgba(99, 102, 241, 0.2)';
        } else if (cellValues.row.status === 'Décalé') {
          bg = theme.palette.mode === 'light' ? 'rgba(100, 116, 139, 0.06)' : 'rgba(100, 116, 139, 0.15)';
          color = '#64748b';
          border = 'rgba(100, 116, 139, 0.2)';
        } else if (cellValues.row.status === '- de 5 personnes' || cellValues.row.status === 'Annulation' || cellValues.row.status === 'À décaler') {
          bg = theme.palette.mode === 'light' ? 'rgba(239, 68, 68, 0.06)' : 'rgba(239, 68, 68, 0.15)';
          color = '#ef4444';
          border = 'rgba(239, 68, 68, 0.2)';
        }

        const pill = (
          <Box
            sx={{
              px: 1.5,
              py: 0.5,
              borderRadius: '12px',
              fontSize: '0.75rem',
              fontWeight: 700,
              backgroundColor: bg,
              color: color,
              border: '1px solid',
              borderColor: border,
              display: 'inline-flex',
              alignItems: 'center'
            }}
          >
            {cellValues.row.status}
          </Box>
        );

        if (cellValues.row.status === 'InscritD' || cellValues.row.status === 'Décalé') {
          return (
            <Tooltip
              followCursor
              enterDelay={500}
              placement="top"
              title={cellValues.row.decalages !== undefined ? cellValues.row.decalages.map((dec) => (
                <span key={`${dec.id}-${dec.number_session}`} style={{ display: 'block', whiteSpace: 'pre-line' }}>
                  {`${dec.name} session: ${dec.number_session}`}
                </span>
              )) : null}
            >
              <span>{pill}</span>
            </Tooltip>
          );
        }

        return pill;
      },
      editable: true,
      valueOptions: ['Inscrit', 'En attente', 'À décaler', 'Décalé', '- de 5 personnes', 'Annulation', 'À transférer'],
      width: 150,
    },
    {
      field: 'start_date',
      headerName: 'Début de session',
      type: 'dateTime',
      editable: user.access_level === 0,
      width: 160,
    },
    {
      field: 'end_date',
      headerName: 'Fin de session',
      type: 'dateTime',
      editable: user.access_level === 0,
      width: 160,
    },
    {
      field: 'progression',
      headerName: 'Progression',
      renderCell: (params) => <ProgressBar value={Number(params.value)} />,
      editable: user.access_level === 0,
      width: 160,
    },
    {
      field: 'real_price',
      headerName: 'Prix',
      valueFormatter: (params) => `${params.value} €`,
      editable: user.access_level === 0,
      width: 100,
    },
    {
      field: 'formation_name',
      headerName: 'Détails',
      type: 'singleSelect',
      renderCell: (cellValues) => (
        (
          <Box sx={{ width: '100%' }}>
            <Box>
              <Link
                sx={{ 
                  whiteSpace: 'normal', 
                  width: 430, 
                  fontWeight: 800,
                  textDecoration: 'none',
                  color: 'text.primary',
                  '&:hover': { color: 'primary.main' }
                }}
                component={RouterLink}
                to={`/dashboard/formations/${cellValues.row.id}`}
              >
                {cellValues.row.formation_name}
              </Link>
            </Box>
            <Collapse in={cellValues.id === clickedId}>
              <Box sx={detailStyles}>
                <Typography variant="body2" sx={{ fontWeight: 500, lineHeight: 1.7, color: 'text.primary' }}>
                  <span style={{ fontWeight: 700, color: 'primary.main' }}>Numéro du programme : </span> {cellValues.row.program_number}
                  <br />
                  <span style={{ fontWeight: 700, color: 'primary.main' }}>Source : </span> {cellValues.row.source}
                  <br />
                  <span style={{ fontWeight: 700, color: 'primary.main' }}>Date de première connexion : </span> {cellValues.row.primary_connection}
                  <br />
                  <span style={{ fontWeight: 700, color: 'primary.main' }}>Date de dernière connexion : </span> {cellValues.row.last_connection}
                </Typography>
              </Box>
            </Collapse>
          </Box>
        )
      ),
      width: 400,
    },
    {
      field: 'actions',
      type: 'actions',
      headerName: 'Actions',
      width: 80,
      cellClassName: 'actions',
      getActions: (params) => [
        <IconButton
          component={RouterLink}
          to={`/dashboard/session/${params.row.sessionId}`}
          sx={{ color: 'primary.main', '&:hover': { backgroundColor: 'rgba(59, 130, 246, 0.05)' } }}
        >
          <ArrowRightAltIcon fontSize="small" />
        </IconButton>
      ],
    },
  ];

  return (
    <>
      {amounts !== null && (
        <Grid
          container
          spacing={3.5}
          sx={{ mb: 5 }}
        >
          <Grid
            item
            lg={3}
            md={6}
            xs={12}
          >
            <Card
              sx={{
                p: 3.5,
                borderRadius: '28px',
                border: '1px solid rgba(16, 185, 129, 0.15)',
                background: theme.palette.mode === 'light' ? 'rgba(255, 255, 255, 0.65)' : 'rgba(15, 23, 42, 0.45)',
                backdropFilter: 'blur(30px)',
                boxShadow: theme.palette.mode === 'light' 
                  ? '0 20px 40px rgba(16, 185, 129, 0.04)' 
                  : '0 20px 40px rgba(16, 185, 129, 0.1)',
                display: 'flex',
                alignItems: 'center',
                gap: 3,
                transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                '&:hover': { 
                  transform: 'translateY(-6px)',
                  boxShadow: '0 25px 50px rgba(16, 185, 129, 0.15)',
                  borderColor: 'success.main'
                }
              }}
            >
              <Avatar
                sx={{
                  backgroundColor: theme.palette.mode === 'light' ? 'rgba(16, 185, 129, 0.08)' : 'rgba(16, 185, 129, 0.15)',
                  color: 'success.main',
                  width: 52,
                  height: 52,
                  boxShadow: '0 4px 12px rgba(16, 185, 129, 0.05)'
                }}
                variant="rounded"
              >
                <Box
                  sx={{
                    animation: 'pulse ease 1.5s infinite',
                    borderRadius: '50%',
                    p: 0.5,
                    '@keyframes pulse': {
                      '0%': { boxShadow: 'none' },
                      '100%': { boxShadow: `0px 0px 0px 8px ${alpha('#10b981', 0.15)}` }
                    }
                  }}
                >
                  <Box
                    sx={{
                      backgroundColor: 'success.main',
                      borderRadius: '50%',
                      height: 12,
                      width: 12
                    }}
                  />
                </Box>
              </Avatar>
              <Box>
                <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.07em' }}>
                  Inscrits
                </Typography>
                <Typography variant="h5" sx={{ mt: 0.5, color: 'text.primary' }}>
                  <span style={{ fontWeight: 900, fontSize: '1.5rem' }}>
                    {numeral(amounts.Inscrit).format('0,000,000').replaceAll(',', ' ')}
                  </span>
                  <span style={{ fontSize: '1rem', color: theme.palette.text.secondary, fontWeight: 700, marginLeft: '4px' }}>€</span>
                </Typography>
              </Box>
            </Card>
          </Grid>
          
          <Grid
            item
            lg={3}
            md={6}
            xs={12}
          >
            <Card
              sx={{
                p: 3.5,
                borderRadius: '28px',
                border: '1px solid rgba(59, 130, 246, 0.15)',
                background: theme.palette.mode === 'light' ? 'rgba(255, 255, 255, 0.65)' : 'rgba(15, 23, 42, 0.45)',
                backdropFilter: 'blur(30px)',
                boxShadow: theme.palette.mode === 'light' 
                  ? '0 20px 40px rgba(59, 130, 246, 0.04)' 
                  : '0 20px 40px rgba(59, 130, 246, 0.1)',
                display: 'flex',
                alignItems: 'center',
                gap: 3,
                transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                '&:hover': { 
                  transform: 'translateY(-6px)',
                  boxShadow: '0 25px 50px rgba(59, 130, 246, 0.15)',
                  borderColor: 'primary.main'
                }
              }}
            >
              <Avatar
                variant="rounded"
                sx={{
                  backgroundColor: theme.palette.mode === 'light' ? 'rgba(59, 130, 246, 0.08)' : 'rgba(59, 130, 246, 0.15)',
                  color: 'primary.main',
                  width: 52,
                  height: 52,
                  boxShadow: '0 4px 12px rgba(59, 130, 246, 0.05)'
                }}
              >
                <TimelapseIcon fontSize="medium" />
              </Avatar>
              <Box>
                <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.07em' }}>
                  InscritD
                </Typography>
                <Typography variant="h5" sx={{ mt: 0.5, color: 'text.primary' }}>
                  <span style={{ fontWeight: 900, fontSize: '1.5rem' }}>
                    {numeral(amounts.InscritD).format('0,000,000').replaceAll(',', ' ')}
                  </span>
                  <span style={{ fontSize: '1rem', color: theme.palette.text.secondary, fontWeight: 700, marginLeft: '4px' }}>€</span>
                </Typography>
              </Box>
            </Card>
          </Grid>

          <Grid
            item
            lg={3}
            md={6}
            xs={12}
          >
            <Card
              sx={{
                p: 3.5,
                borderRadius: '28px',
                border: '1px solid rgba(245, 158, 11, 0.15)',
                background: theme.palette.mode === 'light' ? 'rgba(255, 255, 255, 0.65)' : 'rgba(15, 23, 42, 0.45)',
                backdropFilter: 'blur(30px)',
                boxShadow: theme.palette.mode === 'light' 
                  ? '0 20px 40px rgba(245, 158, 11, 0.04)' 
                  : '0 20px 40px rgba(245, 158, 11, 0.1)',
                display: 'flex',
                alignItems: 'center',
                gap: 3,
                transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                '&:hover': { 
                  transform: 'translateY(-6px)',
                  boxShadow: '0 25px 50px rgba(245, 158, 11, 0.15)',
                  borderColor: 'warning.main'
                }
              }}
            >
              <Avatar
                variant="rounded"
                sx={{
                  backgroundColor: theme.palette.mode === 'light' ? 'rgba(245, 158, 11, 0.08)' : 'rgba(245, 158, 11, 0.15)',
                  color: 'warning.main',
                  width: 52,
                  height: 52,
                  boxShadow: '0 4px 12px rgba(245, 158, 11, 0.05)'
                }}
              >
                <ErrorIcon fontSize="medium" />
              </Avatar>
              <Box>
                <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.07em' }}>
                  À décaler
                </Typography>
                <Typography variant="h5" sx={{ mt: 0.5, color: 'text.primary' }}>
                  <span style={{ fontWeight: 900, fontSize: '1.5rem' }}>
                    {numeral(amounts['À décaler']).format('0,000,000').replaceAll(',', ' ')}
                  </span>
                  <span style={{ fontSize: '1rem', color: theme.palette.text.secondary, fontWeight: 700, marginLeft: '4px' }}>€</span>
                </Typography>
              </Box>
            </Card>
          </Grid>

          <Grid
            item
            lg={3}
            md={6}
            xs={12}
          >
            <Card
              sx={{
                p: 3.5,
                borderRadius: '28px',
                border: '1px solid rgba(239, 68, 68, 0.15)',
                background: theme.palette.mode === 'light' ? 'rgba(255, 255, 255, 0.65)' : 'rgba(15, 23, 42, 0.45)',
                backdropFilter: 'blur(30px)',
                boxShadow: theme.palette.mode === 'light' 
                  ? '0 20px 40px rgba(239, 68, 68, 0.04)' 
                  : '0 20px 40px rgba(239, 68, 68, 0.1)',
                display: 'flex',
                alignItems: 'center',
                gap: 3,
                transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                '&:hover': { 
                  transform: 'translateY(-6px)',
                  boxShadow: '0 25px 50px rgba(239, 68, 68, 0.15)',
                  borderColor: 'error.main'
                }
              }}
            >
              <Avatar
                variant="rounded"
                sx={{
                  backgroundColor: theme.palette.mode === 'light' ? 'rgba(239, 68, 68, 0.08)' : 'rgba(239, 68, 68, 0.15)',
                  color: 'error.main',
                  width: 52,
                  height: 52,
                  boxShadow: '0 4px 12px rgba(239, 68, 68, 0.05)'
                }}
              >
                <WarningIcon fontSize="medium" />
              </Avatar>
              <Box>
                <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.07em' }}>
                  Annulation
                </Typography>
                <Typography variant="h5" sx={{ mt: 0.5, color: 'text.primary' }}>
                  <span style={{ fontWeight: 900, fontSize: '1.5rem' }}>
                    {numeral(amounts.Annulation).format('0,000,000').replaceAll(',', ' ')}
                  </span>
                  <span style={{ fontSize: '1rem', color: theme.palette.text.secondary, fontWeight: 700, marginLeft: '4px' }}>€</span>
                </Typography>
              </Box>
            </Card>
          </Grid>
        </Grid>
      )}

      <Card
        sx={{
          borderRadius: '24px',
          border: '1px solid',
          borderColor: theme.palette.mode === 'light' ? 'rgba(226, 232, 240, 0.8)' : 'rgba(255, 255, 255, 0.05)',
          background: theme.palette.mode === 'light' ? 'rgba(255, 255, 255, 0.65)' : 'rgba(15, 23, 42, 0.45)',
          backdropFilter: 'blur(20px)',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.02)',
          overflow: 'hidden',
          p: 2
        }}
      >
        <Box sx={{ width: '100%' }}>
          <DataGrid
            density="comfortable"
            localeText={frFR.components.MuiDataGrid.defaultProps.localeText}
            initialState={{
              sorting: {
                sortModel: [{ field: 'customer', sort: 'asc' }],
              },
            }}
            autoHeight
            rowHeight={70}
            getRowHeight={({ id, densityFactor }) => {
              if (id === clickedId) {
                return 250 * densityFactor;
              }
              return null;
            }}
            rows={rows}
            columns={columns}
            pageSize={20}
            rowsPerPageOptions={[5, 10, 20, 50]}
            onCellEditCommit={handleChange}
            components={{ Toolbar: CustomToolbar }}
            sx={{
              border: 'none',
              px: 2,
              '& .MuiDataGrid-columnHeaders': {
                backgroundColor: theme.palette.mode === 'light' ? '#f1f5f9' : 'rgba(15, 23, 42, 0.3)',
                borderBottom: `1px solid ${theme.palette.divider}`,
                borderRadius: '12px',
                fontWeight: 700
              },
              '& .MuiDataGrid-columnHeader': {
                color: 'text.secondary',
              },
              '& .MuiDataGrid-cell': {
                borderBottom: theme.palette.mode === 'light' ? '1px solid #f1f5f9' : '1px solid rgba(255, 255, 255, 0.03)',
                color: 'text.primary',
                fontSize: '0.85rem'
              },
              '& .MuiDataGrid-cell[data-field="formation_name"]': {
                whiteSpace: 'normal',
                lineHeight: 1.3,
                display: 'flex',
                alignItems: 'center',
                py: 1
              },
              '& .MuiDataGrid-row:hover': {
                backgroundColor: theme.palette.mode === 'light' ? 'rgba(241, 245, 249, 0.5)' : 'rgba(255, 255, 255, 0.01)',
              },
              '& .MuiDataGrid-footerContainer': {
                borderTop: 'none'
              }
            }}
          />
        </Box>
      </Card>
    </>
  );
};

export default ShiftedLearnersTable;
